import React from 'react';

export const styles = () => {
  return {
    listMetaContainerContainer: {
      display: 'flex',
      flexDirection: 'column' as 'column',
      justifyContent: 'flex-start' as 'flex-start',
      alignItems: 'flex-start' as 'flex-start',
      gap: 8,
      alignSelf: 'flex-start' as 'flex-start',
    } as React.CSSProperties,
    listMetaContainerTextsContainer: {
      display: 'flex',
      flexDirection: 'column' as 'column',
    } as React.CSSProperties,
    listMetaContainerTitleContainer: {
      display: 'flex',
      flexDirection: 'row' as 'row',
      alignItems: 'center' as 'center',
      gap: 4,
    } as React.CSSProperties,
  };
};
